/* 🤖 this file was generated by svg-to-ts */
export const siriusCheckCircleDuotone: {
  name: 'check_circle_duotone';
  data: string;
} = {
  name: 'check_circle_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M21 12a9 9 0 1 1-17.999 0A9 9 0 0 1 21 12Z" fill="currentColor"/><path d="M16.28 9.22a.748.748 0 0 1 0 1.06l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0ZM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12Z" fill="currentColor"/></svg>`
};
